const API = 'https://website-api.audiomeans.fr'
const STRIPE_PUB_KEY = 'pk_live_n7yb1jD2dNcD7aQ8g2RnOFxy001ZvYAt4D'
const GA = 'UA-149030533-1'

export {
  API,
  GA,
  STRIPE_PUB_KEY,
}